import { render, staticRenderFns } from "./PengembalianModal.vue?vue&type=template&id=72e59a08&"
import script from "./PengembalianModal.vue?vue&type=script&lang=js&"
export * from "./PengembalianModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports